export default __webpack_public_path__ + "static/media/chickenarms.0cf2fdf1.png";